<template lang="pug">
AppAlert(
  v-if="show"
  type="warning"
  icon-classes="hi hi-warning"
  message="Job sites with a small radius may be less reliable when mobile hardware or signal quality is diminished."
)
</template>

<script>
// Below this radius, GPS inaccuracy on low-end hardware or in poor-signal
// environments is significant enough to produce unreliable enter/exit events.
const THRESHOLD = 100;

export default {
  name: 'JobSiteSmallRadiusWarning',
  props: {
    radius: { type: Number, default: null },
  },
  computed: {
    show() {
      return this.radius != null && this.radius < THRESHOLD;
    },
  },
};
</script>
